export default __webpack_public_path__ + "assets/56a05743bf20c0f8f2232b5fcd57d05a.png";